import type {
  DeleteAgentMutation,
  DeleteAgentMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const DELETE_AGENT: TypedDocumentNode<
  DeleteAgentMutation,
  DeleteAgentMutationVariables
> = gql`
  mutation DeleteAgent($id: String!) {
    deleteAgent(id: $id) {
      deleted
      message
    }
  }
`;
